import _taggedTemplateLiteral from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  query($order: [GoodsFindOrder!],$where: GoodsFindFilter) {\n    exportGoodsList(\n      order: $order,\n      where: $where\n    ) {\n      fileName\n      contentB64\n    }\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  mutation($dealerId: Int, $isOpening: Boolean!) {\n    openOrCloseStore(\n      dealerId: $dealerId,\n      isOpening: $isOpening\n    )\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  query($goodId: Int!) {\n    findGood(\n      goodId: $goodId\n    ) {\n      author\n      createdAt\n      dealerRelations {\n        dealer {\n          id\n          realname\n          storeName\n          storePhone\n          status\n          user {\n            phone\n          }\n        }\n        details\n        price\n        sharingProportion\n      }\n      coverImages\n      details\n      id\n      isbn\n      managers {\n        createdBy {\n          id\n          username\n        }\n        modifiedBy {\n          id\n          username\n        }\n      }\n      press\n      price\n      publishedDate\n      status\n      subTitle\n      thumb\n      title\n      updatedAt\n      deliveryMethod\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  mutation($goodIds: [Int!]!, $status: GoodStatus!) {\n    changeGoodsStatus(\n      goodIds: $goodIds,\n      status: $status\n    )\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  mutation($goodId: Int!) {\n    deleteGood(\n      goodId: $goodId,\n    )\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query($order: [GoodsFindOrder!], $paging: PagingQuery, $where: GoodsFindFilter) {\n    findGoods(\n      order: $order,\n      paging: $paging,\n      where: $where,\n    ) {\n      goods {\n        author\n        createdAt\n        coverImages\n        dealerRelations {\n          dealer {\n            id\n            realname\n            storeName\n            storePhone\n            status\n            user {\n              phone\n            }\n          }\n          dealerId\n          details\n          goodId\n          price\n          sharingProportion\n        }\n        details\n        id\n        isbn\n        managers {\n          createdBy {\n            id\n            username\n          }\n          modifiedBy {\n            id\n            username\n          }\n        }\n        press\n        price\n        publishedDate\n        status\n        subTitle\n        thumb\n        title\n        updatedAt\n      }\n      paging {\n        currentOffset\n        take\n        totalCount\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from 'graphql-tag';
export var findGoods = gql(_templateObject());
export var deleteGood = gql(_templateObject2());
export var changeGoodsStatus = gql(_templateObject3());
export var findGood = gql(_templateObject4());
export var openOrCloseStore = gql(_templateObject5());
export var exportGoodsList = gql(_templateObject6());